export default "__VITE_ASSET__5nwi5gUW__"